import { useCallback, useRef, useState } from 'react'

export function useIntersectionObserver(
	options: IntersectionObserverInit = {}
) {
	const { root = null, rootMargin = '0px', threshold = 1 } = options
	const [entry, setEntry] = useState<IntersectionObserverEntry | null>(null)

	const previousObserver = useRef<IntersectionObserver | null>(null)

	const customRef = useCallback(
		(node: any) => {
			if (previousObserver.current) {
				previousObserver.current.disconnect()
				previousObserver.current = null
			}

			if (node?.nodeType === Node.ELEMENT_NODE) {
				const observer = new IntersectionObserver(
					([entry]) => {
						setEntry(entry)
					},
					{ root, rootMargin, threshold }
				)

				observer.observe(node)
				previousObserver.current = observer
			}
		},
		[threshold, root, rootMargin]
	)

	return [customRef, entry] as const
}
